export default __webpack_public_path__ + "static/media/checkmark-in-green-circle.34c8c24f.svg";